import React, { useState, useEffect } from 'react';
import { apiClient } from '../../apiClient';

const Card = ({ children, className }) => (
  <div className={`bg-white p-6 rounded-lg shadow-sm ${className}`}>
    {children}
  </div>
);

const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    // APIから返されるタイムスタンプは、ISO文字列か、Firestoreのタイムスタンプオブジェクト形式のいずれか
    const date = timestamp._seconds ? new Date(timestamp._seconds * 1000) : new Date(timestamp);
    
    if (isNaN(date.getTime())) {
        console.error("Invalid date provided to formatTimestamp:", timestamp);
        return '日付不明';
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
};

const TeamCard = () => {
  const [stats, setStats] = useState({ totalMembers: 0, activeMembers: 0, lastUpdated: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTeamStats = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get('/v1/team/stats');

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({ error: 'Failed to parse error response' }));
          throw new Error(errorData.error || `Request failed with status ${response.status}`);
        }

        const data = await response.json();
        setStats(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching team stats:", err);
        setError('データの取得に失敗しました。');
        setStats({ totalMembers: 0, activeMembers: 0, lastUpdated: null });
      } finally {
        setLoading(false);
      }
    };

    fetchTeamStats();
  }, []);

  return (
    <Card>
      <h3 className="font-bold text-gray-800 mb-4">チーム</h3>
      {loading ? (
        <div className="text-center text-gray-500">読み込み中...</div>
      ) : error ? (
        <div className="text-center text-red-500">{error}</div>
      ) : (
        <>
          <div className="flex justify-around items-start text-center">
            <div>
              <p className="text-sm text-gray-500 mb-1">合計メンバー</p>
              <p className="text-3xl font-bold text-gray-800">
                {stats.totalMembers} <span className="text-base font-normal">名</span>
              </p>
            </div>
            <div className="border-l border-gray-200 h-16 mx-4"></div>
            <div>
              <p className="text-sm text-gray-500 mb-1">アクティブ</p>
              <p className="text-3xl font-bold text-gray-800">
                {stats.activeMembers} <span className="text-base font-normal">名</span>
              </p>
              <p className="text-xs text-gray-400 mt-1">過去30日</p>
            </div>
          </div>
          {stats.lastUpdated && (
            <div className="text-right text-xs text-gray-400 mt-4">
              最終更新日時: {formatTimestamp(stats.lastUpdated)}
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default TeamCard;
